import AcessibilidadeService from "@/services/acessibilidade.service";

const actions = {
    getAcessibilidades() {
        AcessibilidadeService.getAll()
            .then(response => alert('teste', response ))
                // context.commit('GET_ACESSIBILIDADES', response))
    }
}

export default actions